/* AppHeaderV2.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["minWidth"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["source"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _29 = "._1n261q9c{flex-wrap:nowrap}";
const _28 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}}";
const _27 = "@media (min-width:64rem){._1inivrvc{flex-direction:row}}";
const _26 = "._1p57xy5q{row-gap:var(--ds-space-400,2pc)}";
const _25 = "._1bah1yb4{justify-content:space-between}";
const _24 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _23 = "._18u0idpf{margin-left:0}";
const _22 = "._otyridpf{margin-bottom:0}";
const _21 = "._2hwxidpf{margin-right:0}";
const _20 = "._19pkidpf{margin-top:0}";
const _19 = "._1ul9s5dg{min-width:var(--_zv6kmu)}";
const _18 = "._1bsb1j0z{width:var(--_ba63p)}";
const _17 = "._1n261g80{flex-wrap:wrap}";
const _16 = "._1bsb1ns9{width:-moz-fit-content;width:fit-content}";
const _15 = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
const _14 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _13 = "._1yt41kqz{padding:var(--ds-space-200,1pc) var(--ds-space-250,20px) var(--ds-space-250,20px) var(--ds-space-250,20px)}";
const _12 = "._19itzgxb{border:1px solid var(--ds-border,#091e4224)}";
const _11 = "._2rkoftgi{border-radius:8px}";
const _10 = "._vwz41k8s{line-height:1.5rem}";
const _9 = "._19pkv77o{margin-top:var(--ds-space-025,2px)}";
const _8 = "._nd4u1b66 h1{margin-bottom:var(--ds-space-050,4px)}";
const _7 = "._rzbyidpf h1{margin-top:0}";
const _6 = "._2hwxpxbi{margin-right:var(--ds-space-200,1pc)}";
const _5 = "._otyr1jfw{margin-bottom:var(--ds-space-500,40px)}";
const _4 = "._2lx21bp4{flex-direction:column}";
const _3 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _2 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _ = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
export const SocialProofHeading = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "dt",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1gjq _otyru2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SocialProofHeading.displayName = 'SocialProofHeading';
}
export const HeaderContainerMPAC = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeaderContainerMPAC.displayName = 'HeaderContainerMPAC';
}
export const HeaderContainerEMCEE = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _otyr1jfw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeaderContainerEMCEE.displayName = 'HeaderContainerEMCEE';
}
export const IconContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2hwxpxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  IconContainer.displayName = 'IconContainer';
}
export const AppDetailsContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _rzbyidpf _nd4u1b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppDetailsContainer.displayName = 'AppDetailsContainer';
}
export const CompatibilitiesContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkv77o _vwz41k8s", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CompatibilitiesContainer.displayName = 'CompatibilitiesContainer';
}
export const TrustSignalsContainer = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "dl",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _12, _13, _14, _15, _16, _3, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkoftgi _19itzgxb _1yt41kqz _zulpxy5q _19pk1ejb _1bsb1ns9 _1e0c1txw _1n261g80", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TrustSignalsContainer.displayName = 'TrustSignalsContainer';
}
export const TrustSignalsItem = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  const {
      minWidth
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _18, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_ba63p": ix(__cmplp.width || 'unset'),
        "--_zv6kmu": ix(__cmplp.minWidth || 'unset')
      }),
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _1bsb1j0z _1ul9s5dg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TrustSignalsItem.displayName = 'TrustSignalsItem';
}
export const ItemValue = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "dd",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_20, _21, _22, _23, _24, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _zulp1b66 _1e0c1txw _2lx21bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ItemValue.displayName = 'ItemValue';
}
export const HeaderTopRowContainer = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded11);
  const {
      source
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _25, _26, _27, _28, _29, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1yb4 _1p57xy5q _1inivrvc _na0i1bp4", __cmplp.source === 'MPAC' ? "_1n261q9c" : "_1n261g80", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeaderTopRowContainer.displayName = 'HeaderTopRowContainer';
}